import { Switch } from '@tonic-one/react';
import React, { forwardRef, useImperativeHandle } from 'react';
import { CommonFormikProps } from './type';
import { useField } from 'formik';
import { TitleLabel } from '../FormComponent';

const SwitchFormik = forwardRef(
  ({ name, label, ...restProps }: CommonFormikProps, ref) => {
    const [field, meta, helpers] = useField(name);
    const { value, onChange } = field;
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    useImperativeHandle(ref, () => ({
      ...meta,
      ...helpers,
      ...inputRef.current,
    }));
    return (
      <>
        <Switch
          ref={inputRef}
          mr="1x"
          value={Number(!!value)}
          checked={!!value}
          onChange={onChange}
          name={name}
          {...restProps}
        />
        <TitleLabel title={label} mr="2x" />
      </>
    );
  }
);
export default SwitchFormik;
